import FlipMove from "react-flip-move"
import { memo } from "react"
import { InfiniteScroll, TableBody } from "grommet";
import { DroppableAuctionTableRow } from "./DroppableAuctionTableRow";
import AuctionTableRowClass from "./AuctionTableRowClass";
import { useSelector } from "react-redux";


const AuctionTableRows = (({ data, hoverTable }) => {
    return (
        <FlipMove typeName="tbody" style={{display: 'table-row-group', verticalAlign: 'middle', borderColor: 'inherit', background: hoverTable ? '#272727' : '' }}>
            {data.map((dataRow, index) => (
                <AuctionTableRowClass
                    key={dataRow.id}
                    dataRow={dataRow}
                    index={index}
                />
            ))}
        </FlipMove>
    )
})

const OptimizedAuctionTableRows = (({ data, hoverTable }) => {
    return (
        <TableBody style={{ background: hoverTable ? '#272727' : '' }}>
            <InfiniteScroll items={data} replace={true}>
                {(dataRow, index) => (
                    <DroppableAuctionTableRow
                        key={dataRow.id}
                        dataRow={dataRow}
                        index={index}
                    />
                )}
            </InfiniteScroll>
        </TableBody>
    )
})

export const AuctionTableBody = memo(({ data }) => {

    const hoverTable = useSelector((state) => state.auctionData.hoverTable);

    if (data.length > 100) {
        return (
            <OptimizedAuctionTableRows data={data} hoverTable={hoverTable} />
        )
    }
    return (
        <AuctionTableRows data={data} hoverTable={hoverTable} />
    )
})